import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CheckCircleIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 20} height={height || 20} viewBox="0 0 20 20">
      <g transform="translate(-332 -415)">
        <circle
          data-name="Elipse 131"
          cx={10}
          cy={10}
          r={10}
          transform="translate(332 415)"
          fill={color || "#2f2f2f"}
        />
        <path
          data-name="Caminho 10029"
          d="M-13.924-4.689a.6.6 0 00.849 0l6.9-6.9a.6.6 0 000-.849l-.849-.849a.6.6 0 00-.849 0L-13.5-7.658l-2.627-2.627a.6.6 0 00-.849 0l-.849.849a.6.6 0 000 .849z"
          transform="translate(354 434.461)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
